import { gql, TypedDocumentNode } from "@apollo/client";

import { WebhooksIntegration } from "types/generated";

type DeleteModuleWebhookData = {
  webhooksIntegrationDelete: Pick<WebhooksIntegration, "id"> | null;
};

type DeleteModuleWebhookVariables = {
  moduleId: string;
  id: string;
};

export const DELETE_MODULE_WEBHOOK: TypedDocumentNode<
  DeleteModuleWebhookData,
  DeleteModuleWebhookVariables
> = gql`
  mutation DeleteModuleWebhook($moduleId: ID!, $id: ID!) {
    webhooksIntegrationDelete(id: $id, stack: $moduleId) {
      id
    }
  }
`;
